export default "__VITE_ASSET__e165016a__"